//
//
//
//
//
//
//
//
//
//
//

	import BM from '../components/js/common';
	import * as Api from '../service/Api';
export default{
    data(){
        return{
        	title: '等待支付',
	        desc: '或支付被取消，請重新支付',
            params: this.$route.query.payParams
        }
    },
	computed: {

	},
	mounted(){
        this.callPay();
	},
	methods:{
		//唤起微信支付
		callPay(){
			var that = this;
			if (typeof WeixinJSBridge == "undefined") {
				if (document.addEventListener) {
					document.addEventListener('WeixinJSBridgeReady', that.jsApiCall, false);
				} else if (document.attachEvent) {
					document.attachEvent('WeixinJSBridgeReady', that.jsApiCall);
					document.attachEvent('onWeixinJSBridgeReady', that.jsApiCall);
				}
			} else {
				that.jsApiCall();
			}
		},
		jsApiCall(){
			let that = this;
			let oData = JSON.parse(this.$route.query.payParams);
			WeixinJSBridge.invoke(
				'getBrandWCPayRequest',
				oData,
				function (res) {
					WeixinJSBridge.log(res.err_msg);

					if (res.err_msg == 'get_brand_wcpay_request:ok') {
						localStorage.setItem('bPaySuccess',true);
                        that.$router.push({
                            path: 'Success'
                        });
						// that.checkFill();
					} else {
						//支付失败
						localStorage.setItem('bPaySuccess',false);
						that.title = '支付失敗';
						that.desc = '支付被取消，請重新支付';
					}
				}
			);
        },
		//是否填写意向
		checkFill(){
			let that = this;
            let localData = JSON.parse(localStorage.getItem('loginData'));

            if(!localData){
                return false
            }
            let oData = {
                name: localData.realname,
                sex: localData.gender,
                mobile: localData.member_phone,
                email: localData.email,
                safeCode: localData.gtjSafeCode,
                safeTime: localData.safetime
            };
            // BM.commonAjax({
            //     url: Api.checkFillUrl,
            //     data: oData,
            //     success: function (res) {
            //         if(res.data.code === 1){
            //             if(!res.data.data.existIntention && !res.data.data.immigrant){
            //                 that.$router.push({
            //                     path: 'Purchase'
            //                 })
            //             }else{
	          //               that.$router.push({
		        //                 path: 'Success'
	          //               });
            //             }
            //         }
            //     },
            //     error: function (res) {
	          //       alert('error')
            //     }
            // })
		},
    }
}



// WEBPACK FOOTER //
// ./src/pages/Pay.vue